import { signupApiConfig, type SignupRouteTypeMap } from 'functions-node-signup/client'
import { backendClient } from '@/utils/backendClient'

export const Signup = backendClient<SignupRouteTypeMap>(signupApiConfig)
